import { Link } from '@tonic-one/react';
import PredictiveMachineLearningModal from '../LogPredictiveMachineLearningModal';
import { useState } from 'react';

export const MalwareDetectedBy = ({ logItem }: { logItem: any }) => {
  const [isOpen, setIsOpen] = useState(false);
  const isPredictiveMachineLearningShow =
    logItem.malwareReport && logItem.malwareDetectedByKey === 'TrendX';
  return (
    <>
      {isPredictiveMachineLearningShow ? (
        <Link
          onClick={() => {
            setIsOpen(true);
          }}
          width="100%"
        >
          {logItem.malwareDetectedBy}
        </Link>
      ) : (
        logItem.malwareDetectedBy
      )}
      {isOpen && (
        <PredictiveMachineLearningModal
          visible={isOpen}
          onClose={() => setIsOpen(false)}
          data={logItem}
        />
      )}
    </>
  );
};
